<template>
  <div id="menu" :class="{ active }" v-if="$route.meta.menu !== false">
    <router-link tag="div" :to="{ name: 'Profile' }" class="user hide-pc">
      <Avatar :src="user.avatar" size="xl" />
      <div class="profile__info">
        <div class="name">
          <span class="hide-pc">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</span>
          <span class="hide-mobile">{{ $t('userMenu.name') }}</span>
        </div>
        <Role :role="user.role" />
      </div>
    </router-link>
    <div class="links">
      <router-link class="link" :to="{ name: 'Dashboard' }">
        <div>
          <img src="@/assets/icons/nav/Dashboard.svg" alt="Dashboard" />
        </div>
        <span>{{ $t('userMenu.dashboard') }}</span>
      </router-link>
      <router-link :to="{ name: 'Schedule' }" class="link">
        <div>
          <img src="@/assets/icons/nav/Schedule.svg" alt="Schedule" />
        </div>
        <span>{{ $t('userMenu.schedule') }}</span>
      </router-link>
      <router-link :to="{ name: 'Experts' }" class="link">
        <div>
          <img src="@/assets/icons/nav/Speakers.svg" alt="Speakers" />
        </div>
        <span>{{ $t('userMenu.experts') }}</span>
      </router-link>
      <router-link :to="{ name: 'Participants' }" class="link">
        <div>
          <img src="@/assets/icons/nav/Attendees.svg" alt="Participants" />
        </div>
        <span>{{ $t('userMenu.participants') }}</span>
      </router-link>
      <router-link :to="{ name: 'Profile' }" class="link">
        <div>
          <img src="@/assets/icons/nav/Profile.svg" alt="Profile" />
        </div>
        <span>{{ $t('userMenu.profile') }}</span>
      </router-link>
      <router-link :to="{ name: 'Materials library' }" class="link">
        <div>
          <img src="@/assets/icons/nav/Library.svg" alt="Library" />
        </div>
        <span>{{ $t('userMenu.materialsLibrary') }}</span>
      </router-link>
      <router-link :to="{ name: 'About' }" class="link">
        <div>
          <img src="@/assets/icons/nav/About.svg" alt="About" />
        </div>
        <span>{{ $t('userMenu.about') }}</span>
      </router-link>
      <router-link :to="{ name: 'Notifications' }" class="link only-mobile">
        <div>
          <img style="width: 25px;" src="@/assets/icons/nav/Noti.svg" alt="Notifications" />
        </div>
        <span>{{ $t('userMenu.notifications') }}</span>
      </router-link>
    </div>
    <hr />
    <a class="copyright" href="https://greentech-ahk-za.kz/" target="_blank">
      {{ $t('userMenu.copyright') }}
    </a>
    <LangSelect />
  </div>
</template>

<script>
import Avatar from './user/Avatar'
import Role from '@/components/user/Role'
import LangSelect from '@/components/navbar/LangSelect'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Menu',
  components: { LangSelect, Role, Avatar },
  computed: {
    active() {
      return this.$store.state.menu
    },
    user() {
      return this.$auth.user() || {}
    },
    ...mapGetters('events', ['notificationNew']),
    ...mapState('events', ['logsIds', 'logsIdsViewed']),
  },
  watch: {
    active(active) {
      if (active) document.body.classList.add('modal-open')
      else document.body.classList.remove('modal-open')
    },
  },
}
</script>

<style lang="scss">
#menu {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 40px 20px;
  width: 100%;
  max-height: 100vh;
  overflow: auto;
  background: $white;
  box-shadow: 12px 16px 36px rgba(180, 187, 198, 0.15);
  transition: all 0.5s;
  z-index: 999;
  .links .link.only-mobile {
    display: none;
  }
  @include mobile {
    .links .link.only-mobile {
      display: flex;
    }
    padding: 80px 40px 40px;
    transform: translateY(-100%);

    &.active {
      transform: translateY(0%);
    }
  }

  .lang {
    font-weight: 700;
    font-size: 12px;
    line-height: 147.5%;
    margin-right: 6px;
  }

  .user {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    margin-bottom: 55px;

    .name {
      font-weight: bold;
      font-size: 16px;
      line-height: 1;
    }

    .user-role {
      margin: 0 auto;
    }

    .avatar {
      width: 83px;
      height: 83px;
      border-radius: 24px;
      margin-right: 15px;
    }
  }

  .links {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 40px;

    .link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      color: $text;
      text-decoration: none;

      @include mobile {
        padding: 15px 0;
        flex-direction: row;
        justify-content: flex-start;
        &:last-child {
          grid-column: 2 / 3;
        }

        &.router-link-active {
          position: relative;
          font-weight: 700;

          &::after {
            content: '';
            position: absolute;
            top: 50%;
            left: -40px;
            width: 3px;
            height: 40px;
            transform: translateY(-50%);
            background: $primary;
          }
        }
      }

      > div {
        width: 26px;
        margin-bottom: 18px;
        transition: all 0.25s;
        position: relative;

        @include mobile {
          margin: 0 15px 0 0;
        }

        img {
          display: block;
          margin: 0 auto;
        }

        .dot-new {
          top: -10px;
          right: -5px;
          width: 8px;
          height: 8px;
          background: $primary;
          position: absolute;
          border-radius: 50%;
          margin: 0 !important;
        }
      }

      span {
        display: block;
        max-width: 100%;
        flex-shrink: 2;
        text-align: center;
        white-space: nowrap;
      }
    }
  }

  hr {
    margin: 32px -40px;
  }

  .copyright {
    display: block;
    max-width: 240px;
    margin: 0 auto;
    text-align: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: #d0d0d0;
  }

  .lang-select {
    position: absolute;
    top: 18px;
    left: 40px;
  }

  @include PC {
    right: unset;
    max-width: 78px;
    padding: 32px 26px 22px;
    overflow: hidden;
    transition: all 0.25s;
    box-sizing: border-box;

    .user {
      flex-direction: row;
      justify-content: flex-start;
      border-bottom: 1px solid #eceff4;
      background: #eceff4;
      overflow-x: hidden;
      margin: -14px -18px;
      margin-bottom: 21px;
      transition: all 0.25s;
      cursor: pointer;

      .avatar {
        width: 35px;
        height: 35px;
        flex-shrink: 0;
        margin: 18px 25px;
        transition: all 0.25s;
      }

      .name {
        margin: 0;
        white-space: nowrap;
      }

      .user-role {
        display: none;
      }
    }

    .links {
      grid-template-columns: 1fr;
      grid-gap: 11px;
      align-content: flex-start;
      min-height: calc(100vh - 116px - 66px - 30px);
      transition: all 0.25s;

      .link {
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-right: -18px;
        min-height: 30px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          left: 48px;
          top: 0;
          bottom: 0;
          width: 0;
          background: $primary;
          transition: all 0.25s;
        }

        div {
          margin: 0 34px 0 0;

          img {
            object-fit: cover;
          }
        }

        &:not(:hover):not(.router-link-active) div img {
          filter: brightness(1);
        }

        &:hover,
        &.router-link-active {
          cursor: pointer;

          &::after {
            width: 40px;
          }
        }
      }
    }

    hr {
      display: none;
    }

    .copyright {
      position: absolute;
      bottom: 74px;
      left: 24px;
      font-size: 10px;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: left top;
      max-width: unset;
      width: 200px;
      transition: all 0.25s;

      @media (max-height: 610px) {
        left: 12px;
        bottom: 50px;
        width: 150px;
      }
    }

    .lang-select {
      position: absolute;
      bottom: 36px;
      top: unset;
      left: unset;
    }

    &:hover {
      max-width: 194px;
      padding-left: 30px;

      .user {
        background: rgba(#eceff4, 0);
        padding: 14px 0 21px 18px;
        margin-bottom: 35px;

        .avatar {
          margin: 0 12px 0 0;
        }
      }

      .links {
        margin-left: 5px;

        .link {
          &::after {
            left: 155px;
          }

          div {
            margin-right: 12px;
          }
        }
      }

      .copyright {
        width: 134px;
        bottom: 80px;
        left: 30px;
        transform: rotate(0deg);
      }
    }
  }
}
</style>
